import fs from "fs";
import path from "path";
import Legal from "app/components/Legal";
import { MetaFunction, useLoaderData } from "@remix-run/react";
import { SEOHandle } from "@nasa-gcn/remix-seo";
import { getSocialMetaTags } from "app/utils/meta";

export const meta: MetaFunction = () =>
  getSocialMetaTags({
    title: "T & C | Promotional Products Now",
    description: "Welcome to Promotional Products Now",
    url: "https://www.promotionalproductsnow.au/terms-conditions",

    extra: [
      {
        tagName: "link",
        rel: "canonical",
        href: "https://www.promotionalproductsnow.au/terms-conditions",
      },
    ],
  });

export function headers() {
  return {
    "Cache-Control": "public, max-age=86400, stale-while-revalidate=86400",
  };
}

export const handle: SEOHandle = {
  getSitemapEntries: async () => [
    {
      route: "/terms-conditions",
      priority: 0.6,
      lastmod: new Date().toISOString(),
      changefreq: "monthly",
    },
  ],
};

export default function Terms(): JSX.Element {
  const { content } = useLoaderData<typeof loader>();

  return (
    <div className="markdown space-y-4">
      <h1 className="text-center text-foreground text-2xl md:text-3xl font-bold">
        Terms & Conditions
      </h1>
      <div className="w-full mx-auto p-4 lg:py-10 lg:px-5">
        <Legal content={content} />
      </div>
    </div>
  );
}

export function loader() {
  const termsFilePath = path.resolve(process.cwd(), "app/contents", "terms.md");
  const termsContent = fs.readFileSync(termsFilePath, "utf-8");
  return { content: termsContent };
}
